import { http } from "../../../utils/http";
import LocalStorageService from "../../../utils/LocalStorageService";
import { showSuccessSnackbar, showErrorSnackbar } from "../snackbar/index";
import { loginUserSuccess } from "../login/index";

import { SIGNUP_FAILURE, SIGNUP_REQUEST, SIGNUP_SUCCESS } from "./types";

const localStorageService = LocalStorageService.getService();

export const signupRequestAction = () => ({
  type: SIGNUP_REQUEST,
  isLoading: true,
});

export const signupSuccessAction = (payload) => ({
  type: SIGNUP_SUCCESS,
  payload,
  isLoading: false,
  isSuccesfull: true,
});

export const signupFailureAction = (errors) => ({
  type: SIGNUP_FAILURE,
  isLoading: false,
  isSuccesfull: false,
  errors,
});

export const registerUser = (user) => (dispatch) => {
  dispatch(signupRequestAction());
  return http
    .post("/api/users/", { user })
    .then((res) => {
      const { response } = res.data;
      dispatch(signupSuccessAction(response));
      dispatch(loginUserSuccess());
      localStorageService.setToken(res.data.user);
      dispatch(showSuccessSnackbar(`Signup successful. Welcome to HairQ`));
    })
    .catch((errors) => {
      dispatch(signupFailureAction(errors.response?.data.errors));
      dispatch(
        showErrorSnackbar(
          errors.response?.data.errors.email ??
            errors.response?.data.errors.password ??
            "Please check your internet connection"
        )
      );
    });
};

//Reducer for signUp
export const signUpReducer = (state = { isLoading: false }, action) => {
  switch (action.type) {
    case SIGNUP_REQUEST:
      return { ...state, isLoading: action.isLoading };
    case SIGNUP_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: action.errors,
        isSuccesfull: action.isSuccesfull,
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        response: action.payload,
        isSuccesfull: action.isSuccesfull,
      };
    default:
      return state;
  }
};

export default signUpReducer;
